import $ from 'jquery';

function TermNavigation(element) {
  this.element = element;
  this.$element = $(element);
  this.$menus = this.getMenus();
  this.setCurrentlyActiveState();
  this.addMobileBehavior();
  this.listen();
  this.ready();
}

TermNavigation.prototype = {
  getMenus() {
    const $menus = this.$element.find('.block-content .expanded');
    const $filteredMenus = $menus.has('li a');
    $menus.removeClass('expanded');
    $filteredMenus.addClass('expanded');
    return $filteredMenus;
  },
  onClick(event) {
    const shouldExpand = $(event.target).is('.menu-link');
    if (shouldExpand) {
      $(this).parent().toggleClass('expanded collapsed');
      event.preventDefault();
    }
  },
  addMobileBehavior() {
    const $spot = $('<span class="hotspot"></span>');
    this.$element.find('.block-title a').append($spot);

    // Add a click handler to control the mobile dropdown menu
    $spot.on('click', (event) => {
      event.preventDefault();
      this.$element.toggleClass('expanded');
    });
  },
  setCurrentlyActiveState() {
    // set all to collapsed other than the active items
    this.$menus.not('.active-trail').toggleClass('expanded collapsed');
  },
  listen() {
    // set up an click listener to control the each submenu visibility
    this.$menus.find('> a').on('click', this.onClick);
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default TermNavigation;



// WEBPACK FOOTER //
// ./TermNavigation.js